import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/allocation/list/task/styles.scss';export default {
  "main": "_main_1n0lv_1",
  "header": "_header_1n0lv_7",
  "iconBox": "_iconBox_1n0lv_18",
  "icon": "_icon_1n0lv_18",
  "openedIcon": "_openedIcon_1n0lv_34",
  "row": "_row_1n0lv_38",
  "avatar": "_avatar_1n0lv_45",
  "col": "_col_1n0lv_50",
  "name": "_name_1n0lv_59",
  "profession": "_profession_1n0lv_64",
  "recordList": "_recordList_1n0lv_69"
};